import { Circle, Square, AlertTriangle, CheckCircle2, Upload } from "lucide-react";

function fmt(ms) {
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  return `${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}:${String(ss).padStart(2,"0")}`;
}

export default function MatchRecorderControls({ recorder, flat = false }) {
  const { state, error, elapsedMs, uploadProgress, start, stop, cancel } = recorder;
  const wrapperCls = flat
    ? "flex items-center gap-2 text-xs"
    : "rounded-xl border border-border-default bg-bg-primary p-3 flex items-center gap-3 text-sm";
  return (
    <div className={wrapperCls}>
      {/* status dot */}
      {state === "recording" && (
        <span className="flex items-center gap-1.5 text-red-400">
          <Circle className="w-3 h-3 fill-red-400 animate-pulse" />
          <span className="font-mono">REC</span>
        </span>
      )}
      {state === "complete" && <CheckCircle2 className="w-4 h-4 text-emerald-400" />}
      {state === "error"    && <AlertTriangle className="w-4 h-4 text-red-400" />}

      {/* clock */}
      <span className="font-mono text-text-primary">{fmt(elapsedMs)}</span>

      <div className="flex-1" />

      {/* upload progress */}
      {(uploadProgress.uploaded > 0 || uploadProgress.queued > 0) && (
        <span className="flex items-center gap-1 text-xs text-text-secondary">
          <Upload className="w-3 h-3" />
          {uploadProgress.uploaded} chunks ↑
          {uploadProgress.queued > 0 && (
            <span className="text-amber-400 ml-1">+{uploadProgress.queued} queued</span>
          )}
        </span>
      )}

      {/* buttons */}
      {state === "idle" && (
        <button
          onClick={start}
          className="px-3 py-1.5 rounded-md bg-red-500/15 border border-red-500/40 text-red-400 hover:bg-red-500/25"
        >
          ● Start recording
        </button>
      )}
      {state === "recording" && (
        <button
          onClick={stop}
          className="px-3 py-1.5 rounded-md bg-bg-secondary border border-border-default hover:border-button-primary flex items-center gap-1.5"
        >
          <Square className="w-3 h-3" /> Stop &amp; finalize
        </button>
      )}
      {state === "starting" && <span className="text-text-secondary text-xs">starting…</span>}
      {state === "stopping" && <span className="text-text-secondary text-xs">finalizing upload…</span>}
      {state === "error" && (
        <button onClick={cancel} className="text-xs text-text-secondary underline">cancel &amp; reset</button>
      )}

      {error && <span className="text-xs text-red-400 truncate max-w-xs">{error}</span>}
    </div>
  );
}
